// extracted by mini-css-extract-plugin
export default {"image":"styles_image__Ke3Wx","fullWidth":"styles_fullWidth__nYoVb"};